import { EllipsisIcon } from "@xola/icons";
import { ICellRendererParams } from "ag-grid-community";
import { canCancel } from "common";
import React from "react";
import { PurchaseActionMenu } from "../PurchaseActionMenu";
import { MerchandiseOrdersRowData } from "./useMerchandiseOrdersData";
import { SecondaryButton } from "@/components/Common/SecondaryButton";
import { useVisibility } from "@/hooks/useVisibility";
import { getMerchandisePurchaseItems } from "@/models/MerchandisePurchaseItem";

export const MerchandiseActionCellRenderer = ({ data }: ICellRendererParams<MerchandiseOrdersRowData>) => {
    const [isVisible, { toggle: handleToggle }] = useVisibility(false);

    if (!data) {
        return null;
    }

    const merchandiseItems = getMerchandisePurchaseItems(data.purchase);
    const activeMerchandiseItem = merchandiseItems.find((item) => canCancel(item)) ?? merchandiseItems[0];

    if (!activeMerchandiseItem) {
        return null;
    }

    return (
        <span data-testid="merchandise-action-button">
            <SecondaryButton
                data-testid="merchandise-item-menu"
                size="tiny"
                onClick={(e) => {
                    e.stopPropagation();
                    handleToggle();
                }}
            >
                <EllipsisIcon />
            </SecondaryButton>

            {isVisible && data.purchase && (
                <PurchaseActionMenu
                    isOrganizer
                    isMerchandise
                    item={activeMerchandiseItem}
                    isVisible={isVisible}
                    popoverParentId="merchandise-dashboard-list"
                    size="tiny"
                    purchase={data.purchase}
                    onClose={handleToggle}
                />
            )}
        </span>
    );
};
